module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-FLOW-VIDEO2.f12a4f03.png";